function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#EEF4FF",
  d: "M0 22.875h131.25v123.958H0z"
}), React.createElement("path", {
  d: "M78.614 5.698H93.62v93.95H78.614V57.372H35.292v42.278H20.417V5.698h14.875v37.45h43.322V5.698zM122.85 19.79c-5.35 0-9.917-4.175-9.917-9.525 0-5.09 4.567-9.265 9.917-9.265s9.918 4.176 9.918 9.265c0 5.35-4.568 9.525-9.918 9.525zm-7.437 12.005h14.875V99.65h-14.875V31.795zm52.717 36.406h-12.266l-2.61-60.285h17.485l-2.61 60.285zm-6.003 10.57c6.133 0 11.614 4.828 11.614 11.222 0 5.872-5.35 10.96-11.614 10.96-6.263 0-11.613-5.088-11.613-10.96 0-6.394 5.48-11.222 11.613-11.222z",
  stroke: "#5320EE",
  strokeWidth: 1.5
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 175,
    height: 147,
    viewBox: "0 0 175 147"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/display_icon.28dc8660.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/defineNeed/display_icon.svg
// module id = 451
// module chunks = 0